/*
  SLIMZ — Fit Guide: "See your size on real women" (M22d, 2026-09-13).

  Reads the labelled customer photos the section prints (every colourway of every
  fit, from snippets/slimz-pdp-bodies.liquid), keeps ONE photo per woman per fit
  (the same woman in five colours is one data point, not five), and lets the
  shopper filter by the SLIMZ size she is wearing. Each card names the fit and
  links to it, so "Sandra, usually a US 6, wears M in the Tank Top" is one tap
  from buying the Tank Top.
*/
(() => {
  const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

  const init = () => {
    const root = document.querySelector('[data-fg-bodies-root]');
    if (!root || root.dataset.ready) return;
    const dataEl = root.querySelector('[data-fg-bodies]');
    let rows = [];
    try {
      rows = JSON.parse(dataEl.textContent).filter(Boolean);
    } catch (e) {
      return;
    }
    const seen = new Set();
    const cards = [];
    rows.forEach((row) => {
      row.shots.forEach((shot) => {
        const key = row.fit + '|' + shot.model + '|' + shot.size;
        if (seen.has(key)) return;
        seen.add(key);
        cards.push({ fit: row.fit, url: row.url, color: row.color, ...shot });
      });
    });
    if (!cards.length) return;
    root.dataset.ready = 'true';
    root.hidden = false;

    const sizesEl = root.querySelector('[data-fg-sizes]');
    const grid = root.querySelector('[data-fg-grid]');
    const present = ORDER.filter((s) => cards.some((c) => c.size === s));
    let current = 'all';
    let expanded = false;
    const LIMIT = 8;
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'slimz-btn slimz-btn--ghost slimz-fg__more';
    more.addEventListener('click', () => {
      expanded = true;
      paint();
    });
    grid.after(more);

    const paint = () => {
      grid.textContent = '';
      let list = cards
        .filter((c) => current === 'all' || c.size === current)
        .sort((a, b) => ORDER.indexOf(a.size) - ORDER.indexOf(b.size) || a.fit.localeCompare(b.fit));
      // "All" deals the sizes out in turn — XXS, XS, S, M, L, XL, then round again —
      // so the first screen shows the RANGE rather than eight women in XXS. On a
      // phone 31 cards was sixteen screens of scrolling, so it opens at eight.
      if (current === 'all') {
        const bySize = ORDER.map((sz) => list.filter((c) => c.size === sz));
        const dealt = [];
        for (let i = 0; dealt.length < list.length; i++) bySize.forEach((b) => b[i] && dealt.push(b[i]));
        list = dealt;
      }
      const total = list.length;
      if (!expanded && total > LIMIT) list = list.slice(0, LIMIT);
      more.hidden = expanded || total <= LIMIT;
      more.textContent = 'Show all ' + total;
      list.forEach((c) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.className = 'slimz-fg__body';
          a.href = c.url + '?color=' + encodeURIComponent(String(c.color).toLowerCase().replace(/\s+/g, '-'));
          const media = document.createElement('span');
          media.className = 'slimz-fg__body-media';
          const img = document.createElement('img');
          img.src = c.src;
          img.loading = 'lazy';
          img.alt = c.alt || '';
          media.appendChild(img);
          const size = document.createElement('span');
          size.className = 'slimz-fg__body-size';
          size.textContent = c.size;
          media.appendChild(size);
          const who = document.createElement('span');
          who.className = 'slimz-fg__body-who';
          who.textContent = c.model + ' · usually a US ' + c.us;
          const fit = document.createElement('span');
          fit.className = 'slimz-fg__body-fit';
          fit.textContent = 'Wears ' + c.size + ' in the ' + c.fit;
          a.append(media, who, fit);
          li.appendChild(a);
          grid.appendChild(li);
        });
      sizesEl.querySelectorAll('button').forEach((b) => {
        const on = b.dataset.size === current;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };

    ['all'].concat(present).forEach((s) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'slimz-fg__size';
      b.dataset.size = s;
      const n = s === 'all' ? cards.length : cards.filter((c) => c.size === s).length;
      b.textContent = (s === 'all' ? 'All' : s) + ' (' + n + ')';
      b.addEventListener('click', () => {
        current = s;
        expanded = false;
        paint();
      });
      sizesEl.appendChild(b);
    });

    // The finder on the same page answers "what size am I?" — when it does, the
    // photos follow, so the next thing she sees is women wearing that size.
    document.addEventListener('slimz:size-found', (e) => {
      const s = e.detail && e.detail.size;
      if (s && present.indexOf(s) >= 0) {
        current = s;
        paint();
      }
    });

    paint();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
